export var CALLBACK_FREQUENCY = Object.freeze({
  CHANGE: 'change',
  ALWAYS: 'always'
});